import React from 'react';
import './Gmap.css'

const GMap = () => {
    return (
        <div style={{height: '250px',padding: '25px'}}>
            <img className=" map-area" src="https://www.uhlbd.com/backend/web/post_uploads/1468923345map.jpg" alt=""/>
        </div>
    );
};

export default GMap;